var map = {
	"./V1.jpg": 8078,
	"./V2.jpg": 8392,
	"./V3.jpg": 4954,
	"./V4.jpg": 2169,
	"./V5.jpg": 1680,
	"./V6.jpg": 3952,
	"./V7.jpg": 7664,
	"./V8.jpg": 461,
	"./imageA.jpg": 7721,
	"./imageB.jpg": 7134,
	"./imageC.jpg": 3354,
	"./imageD.jpg": 8098,
	"./imageE.jpg": 4911
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4875;